var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreathingExercises(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#d6ecf0",
    cx: 63.5,
    cy: 63.61,
    r: 63.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#32a1b3",
    d: "M27.47,61.31h61.76c7.4,0,13.42-6.02,13.42-13.42s-6.02-13.42-13.42-13.42-13.42,6.02-13.42,13.42c0,1.72,1.4,3.12,3.12,3.12s3.12-1.4,3.12-3.12c0-3.95,3.22-7.17,7.17-7.17s7.17,3.22,7.17,7.17-3.22,7.17-7.17,7.17H27.47c-1.72,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32a1b3",
    d: "M27.47,50.48h34.31c7.4,0,13.42-6.02,13.42-13.42s-6.02-13.42-13.42-13.42-13.42,6.02-13.42,13.42c0,1.72,1.4,3.12,3.12,3.12s3.12-1.4,3.12-3.12c0-3.95,3.22-7.17,7.17-7.17s7.17,3.22,7.17,7.17-3.22,7.17-7.17,7.17H27.47c-1.72,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32a1b3",
    d: "M89.23,65.9H27.47c-1.72,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12h61.76c3.95,0,7.17,3.22,7.17,7.17s-3.22,7.17-7.17,7.17-7.17-3.22-7.17-7.17c0-1.72-1.4-3.12-3.12-3.12s-3.12,1.4-3.12,3.12c0,7.4,6.02,13.42,13.42,13.42s13.42-6.02,13.42-13.42-6.02-13.42-13.42-13.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32a1b3",
    d: "M61.78,76.74H27.47c-1.72,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12h34.31c3.95,0,7.17,3.22,7.17,7.17s-3.22,7.17-7.17,7.17-7.17-3.22-7.17-7.17c0-1.72-1.4-3.12-3.12-3.12s-3.12,1.4-3.12,3.12c0,7.4,6.02,13.42,13.42,13.42s13.42-6.02,13.42-13.42-6.02-13.42-13.42-13.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathingExercises);
export default __webpack_public_path__ + "static/media/breathing-exercises.9d04c7c070713aa2c85376a9e4a301e4.svg";
export { ForwardRef as ReactComponent };